<template>
  <div class="page">
    <template v-if="!noRights">
      <div style="display:none" v-title>注册 - 唯丝普</div>
      <div class="register-favor" :style="avatar"></div>
      <div class="register-form">
        <div class="input-item">
          <span class="input-item-text">医院名称</span>
          <input type="text" v-model="hosName" placeholder="请输入医院名称" readonly />
        </div>
        <div class="input-item">
          <span class="input-item-text">医院地址</span>
          <input type="text" v-model="hosAddress" placeholder="请输入医院地址" readonly />
        </div>
        <div class="input-item">
          <span class="input-item-text">医院电话</span>
          <input type="text" v-model="hosPhone" placeholder="请输入医院电话" readonly />
        </div>
        <div class="input-item">
          <span class="input-item-text">科室</span>
          <input v-model="section" type="text" placeholder="请输入科室" />
        </div>
        <div class="input-item">
          <span class="input-item-text">姓名</span>
          <input type="text" v-model="name" placeholder="请输入姓名" />
        </div>

        <div class="input-item">
          <span class="input-item-text">职称</span>
          <input type="text" v-model="title" placeholder="请输入职称" />
        </div>
        <div class="input-item">
          <span class="input-item-text">年龄</span>
          <input type="text" v-model="age" placeholder="请输入年龄" />
        </div>
        <div class="input-item">
          <span class="input-item-text">性别</span>
          <div class="input-other">
            <span @click="selectSex(1)">
              <span class="input-radio-item" :class="{'input-radio-item-active': sex === 1}"></span> 男
            </span>
            <span @click="selectSex(2)" class="ml-40">
              <span class="input-radio-item" @click="selectSex(2)" :class="{'input-radio-item-active': sex === 2}"></span> 女
            </span>
          </div>
        </div>
        <div class="input-item">
          <span class="input-item-text">手机</span>
          <input type="text" v-model="phone" placeholder="请输入手机" />
        </div>
        <div class="input-item">
          <span class="input-item-text">密码</span>
          <input type="password" v-model="password" placeholder="请输入6位以上的密码" />
        </div>
        <div class="input-item">
          <span class="input-item-text">确认密码</span>
          <input type="password" v-model="rePassword"  placeholder="请输入确认密码" />
        </div>
        <div class="input-item">
          <span class="input-item-text">验证码</span>
          <div class="input-other input-code">
            <input type="text" v-model="code" placeholder="请输入验证码" />
            <span class="input-code-btn" @click="getCode" :class="{'input-code-btn-active': hasSent}">{{codeText}}</span>
          </div>
        </div>
        <div class="register-btn" @click="toRegeister">注册</div>
      </div>
      <div class="wsp-loading" v-show="showTip">
        <div class="wsp-mask"></div>
        <div class="wsp-loading-box">
          <span class="wsp-loading-icon"></span>
          <span class="wsp-loading-text">注册中...</span>
        </div>
      </div>
      <div v-show="showRegisterOk">
        <div class="wsp-mask"></div>
        <div class="wsp-success-box">
          <span class="wsp-success-icon"></span>
          <span class="wsp-success-text1">注册成功</span>
          <span class="wsp-success-text2">{{hosName}}</span>
        </div>
      </div>
    </template>
    <template v-if="noRights">
      <div class="no-rights">参数错误！</div>
    </template>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
import { validateEmpty, validateTel } from '../utils/validator'
import { mapGetters } from 'vuex'
import md5 from 'js-md5'
export default {
  name: 'Register',
  data () {
    return {
      showTip: false,
      showRegisterOk: false,
      hasSent: false,
      codeText: '获取验证码',
      time: 60,
      sex: 1,
      section: '',
      title: '',
      name: '',
      phone: '',
      age: '',
      password: '',
      rePassword: '',
      code: '',
      hosName: '',
      hosAddress: '',
      hosPhone: '',
      st: '',
      noRights: false,
      avatarUrl: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    avatar: function () {
      return this.avatarUrl ? 'background-image:url("' + this.avatarUrl + '")' : ''
    }
  },
  created () {
    let secret = 'tL92QZVP5WS1b7X8'
    let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
    let formet = 'json'
    let serial = Date.parse(new Date()) / 1000
    let ver = '1.0'
    let comcode = this.$route.query.comcode

    let openid = this.$route.query.openid

    let sign1 = md5(secret + appkey + comcode + formet + openid + serial + ver)
    let params1 = {
      serial: serial,
      ver: ver,
      formet: formet,
      secret: secret,
      appkey: appkey,
      sign: sign1,
      comcode: comcode,
      openid: openid
    }
    // 公司信息
    this.$axios.get('/Index/Doctor/CompanyInfo', { params: params1 }).then((response) => {
      if (response.data.code !== 1000) {
        this.noRights = true
      } else {
        this.hosName = response.data.data[0].name
        this.avatarUrl = response.data.data[0].avatar
        this.hosAddress = response.data.data[0].address || '无'
        this.hosPhone = response.data.data[0].phone || '无'
      }
    }).catch(function () {})
  },
  // watch: {
  //   showRegisterOk: function (val, old) {
  //     if (val) {
  //       this.$nextTick(() => {
  //         document.body.style.overflowY = 'hidden'
  //       })
  //     } else {
  //       this.$nextTick(() => {
  //         document.body.style.overflowY = 'scroll'
  //       })
  //     }
  //   }
  // },
  methods: {
    // 注册账号
    toRegeister () {
      if (validateEmpty(this.section)) {
        Toast({
          message: '请输入所属科室！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.name)) {
        Toast({
          message: '请输入姓名！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.title)) {
        Toast({
          message: '请输入所属职称！',
          duration: 1500
        })
        return
      }
      if (isNaN(this.age) || this.age < 1 || this.age > 100) {
        Toast({
          message: '请输入正确的年龄！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.phone)) {
        Toast({
          message: '请输入手机号码！',
          duration: 1500
        })
        return
      }
      if (validateTel(this.phone)) {
        Toast({
          message: '请输入正确的手机号码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.password)) {
        Toast({
          message: '请输入密码！',
          duration: 1500
        })
        return
      }
      if (this.password.length < 6) {
        Toast({
          message: '请输入6位以上的密码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.rePassword)) {
        Toast({
          message: '请输入确认密码！',
          duration: 1500
        })
        return
      }
      if (this.password !== this.rePassword) {
        Toast({
          message: '两次密码不相同！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.code)) {
        Toast({
          message: '请输入验证码！',
          duration: 1500
        })
        return
      }
      let secret = 'tL92QZVP5WS1b7X8'
      let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
      let formet = 'json'
      let serial = Date.parse(new Date()) / 1000
      let ver = '1.0'
      let comcode = this.$route.query.comcode
      let openid = this.$route.query.openid
      let sign = md5(secret + this.age + appkey + comcode + formet + this.name + openid + md5(this.password) + this.phone + this.section + serial + this.sex + this.code + this.title + ver)
      let params = {
        serial: serial,
        ver: ver,
        formet: formet,
        secret: secret,
        appkey: appkey,
        sign: sign,
        section: this.section,
        name: this.name,
        title: this.title,
        sex: this.sex,
        phone: this.phone,
        age: this.age,
        smscode: this.code,
        password: md5(this.password),
        comid: comcode,
        openid: openid
      }
      // 注册
      this.showTip = true
      this.$axios.get('/Index/Doctor/Register', { params: params }).then((response) => {
        if (response.data.code === 1000) {
          this.showTip = false
          this.showRegisterOk = true
          setTimeout(() => {
            this.showRegisterOk = false
          }, 1500)
          setTimeout(() => {
            this.$router.replace({
              path: '/Doctor/UserCenter',
              query: {
                comcode: comcode,
                openid: this.$route.query.openid,
                doctorid: response.data.data[0].doctorid
              }
            })
          }, 2500)
        } else if (response.data.code === 313) {
          this.showTip = false
          this.showRegisterOk = false
          Toast({
            message: '医生手机号码已存在！',
            duration: 1500
          })
        } else {
          this.showTip = false
          this.showRegisterOk = false
          Toast({
            message: '注册失败！',
            duration: 1500
          })
        }
      }).catch(function () {})
    },
    // 选择性别
    selectSex (sex) {
      this.sex = sex
    },
    // 获取验证码
    getCode () {
      if (this.hasSent) {
        return
      }
      if (validateEmpty(this.section)) {
        Toast({
          message: '请输入所属科室！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.name)) {
        Toast({
          message: '请输入姓名！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.title)) {
        Toast({
          message: '请输入所属职称！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.phone)) {
        Toast({
          message: '请输入手机号码！',
          duration: 1500
        })
        return
      }
      if (validateTel(this.phone)) {
        Toast({
          message: '请输入正确的手机号码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.password)) {
        Toast({
          message: '请输入密码！',
          duration: 1500
        })
        return
      }
      if (validateEmpty(this.rePassword)) {
        Toast({
          message: '请输入确认密码！',
          duration: 1500
        })
        return
      }
      if (this.password !== this.rePassword) {
        Toast({
          message: '两次密码不相同！',
          duration: 1500
        })
        return
      }
      let secret = 'tL92QZVP5WS1b7X8'
      let appkey = 'b9916545aR3c35E71fYFedq3b8i6ea9f'
      let formet = 'json'
      let serial = Date.parse(new Date()) / 1000
      let ver = '1.0'
      let sign = md5(secret + appkey + formet + this.phone + serial + ver)
      let params = {
        serial: serial,
        ver: ver,
        formet: formet,
        secret: secret,
        appkey: appkey,
        sign: sign,
        phone: this.phone
      }
      // 用户信息
      this.$axios.get('/Index/Doctor/SmsCode', { params: params }).then((response) => {
        this.hasSent = true
        clearInterval(this.st)
        this.st = setInterval(() => {
          if (this.time > 1) {
            this.time--
            this.codeText = this.time + 's'
          } else {
            this.time = 60
            this.codeText = '获取验证码'
            this.hasSent = false
            clearInterval(this.st)
          }
        }, 1000)
      }).catch(function () {})
    }
  }
}
</script>
<style lang="stylus" scoped>
.page
  width 720px
  margin 0 auto
.register-favor
  margin 30px auto
  width 232px
  height 232px
  background-size 232px auto
  background-position 100% center
  font-size: 24px; /*px*/
  background-image url('../assets/images/no-user.png')
  background-repeat no-repeat
  background-position center center
.register-form
  width 100%
  padding 30px 30px 60px 30px
  background-color #fafafa
  .input-item
    margin-bottom 50px
  .input-item-text
    position relative
    display inline-block
    width 162px
    margin-right 12px
    font-size: 33px; /*px*/
    color #333333
    text-align justify
    line-height 0
    text-align-last justify
    &:after
      position absolute
      right -34px
      top 0
      content '：'
      font-size: 33px; /*px*/
      color #333333
  input
    border-bottom: 1px solid #eaeaea; /*no*/
    width 475px
    height 46px
    padding-left 30px
    line-height 46px
    font-size: 29px; /*px*/
    background-color transparent
    color #666
  .input-other
    display inline-block
    width 475px
    height 46px
    padding-left 30px
    line-height 46px
    font-size: 29px; /*px*/
    // border-bottom: 1px solid #eaeaea; /*no*/
    // padding-bottom 2px
    color #666
  .input-radio-item
    display inline-block
    width 43px
    height 43px
    vertical-align middle
    border: 1px solid #999899; /*no*/
    border-radius 43px
    margin-right 10px
  .input-radio-item-active
      border none
      background-image url('../assets/images/icon-radio.png')
      background-size 43px 43px
  .input-code
    position relative
    input
      margin-left -30px
  .input-code-btn
    position absolute
    top -30px
    right 0
    display inline-block
    width 210px
    height 68px
    line-height 68px
    color #666666
    text-align center
    font-size: 25px; /*px*/
    border-radius 5px
    border: 1px solid #999899; /*no*/
  .input-code-btn-active
    border none
    color #ffffff
    background-image url('../assets/images/icon-code-bg.png')
    background-size 210px 68px
.register-btn
  margin 0 auto
  width 664px
  height 86px
  line-height 86px
  text-align center
  font-size: 35px; /*px*/
  letter-spacing 7px
  color #ffffff
  background-color #c4c4c4
  border-radius 5px
  background-image url('../assets/images/l-btn.png')
  background-size 664px 86px
  background-repeat no-repeat
  font-weight 300

.wsp-mask
  position fixed
  top 0
  left 0
  bottom 0
  right 0
  background-color rgba(0,0,0,.5)
.wsp-loading-box
  position fixed
  top 50%
  left 50%
  transform translate(-50%, -50%)
  width 280px
  height 300px
  background-color #ffffff
  border-radius 20px
  text-align center
.wsp-loading-icon
  display inline-block
  width 92px
  height 92px
  margin-top 78px
  background-image url('../assets/images/icon-loading.png')
  background-size 100%
  background-repeat no-repeat
  animation kwinkle ease-out 1s infinite
.wsp-loading-text
  margin-top 46px
  display block
  color #333333
  font-size: 27px; /*px*/
.wsp-success-icon
    display inline-block
    width 117px
    height 117px
    margin-top 56px
    background-image url('../assets/images/icon-success.png')
    background-size 100%
    background-repeat no-repeat
.wsp-success-box
  position fixed
  top 50%
  left 50%
  transform translate(-50%, -50%)
  width 455px
  height 337px
  padding-left 10px
  padding-right 10px
  background-color #ffffff
  border-radius 20px
  text-align center
.wsp-success-text1
  margin-top 18px
  display block
  color #333333
  font-size: 27px; /*px*/
.wsp-success-text2
  margin-top 32px
  display block
  color #333333
  font-size: 31px; /*px*/
  width 100%
  line-height 120%
.ml-40
  margin-left 40px
@keyframes kwinkle {
  0% {
    transform: rotate(0deg)
  }
  100% {
    transform: rotate(360deg)
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Register.vue